<template>
    <div class="main">
        <topback title="My Team" path="back"></topback>
        <!-- <span slot="right" @click="go_buy_tutorial">Buy Tutotial</span> -->
        <div class="team-list" slot="children">
            <div class="noassets" v-if="nodata">
                <md-result-page class="customized" img-url="/static/icon/noassets.png" text="No member yet"
                    subtext="">
                </md-result-page>
                <md-button class="mt-3" type="primary" @click="goto_invitelinkmanage">Add Invite link</md-button>
            </div>
            <md-scroll-view  ref="listscrollView" :scrolling-x="false" @refreshing="$_onRefresh" :auto-reflow="true" :immediate-check-end-reaching="true"
                @end-reached="$_onEndReached">
                <md-scroll-view-refresh slot="refresh" slot-scope="{ scrollTop, isRefreshActive, isRefreshing }"
                    :scroll-top="scrollTop" :is-refreshing="isRefreshing" :is-refresh-active="isRefreshActive"
                    refresh-text="pull to refresh" refresh-active-text="release refreshable"
                    refreshing-text="refresh"></md-scroll-view-refresh>
                    <md-field class="historylist pt-0">
                        <myteamitem :ch="ch" v-for="ch in children" v-bind:key="ch.id"></myteamitem>
                    </md-field>
                <md-scroll-view-more slot="more" :is-finished="isFinished" loading-text="Loading" finished-text="no more data">
                </md-scroll-view-more>
            </md-scroll-view>
        </div>

    </div>
</template>

<script>
import topback from '@/components/topback'
import iconimg from '@/components/iconimg'
import card from '@/components/card'
import myteamitem from './myteamitem'
import { getmyteam } from '@/request/api'

export default {
    name: 'myteam',
    components: {
        [topback.name]: topback,
        iconimg,
        card,
        myteamitem
    },
    data() {
        return {
            teaminfo: {},
            page: 1,
            limit: 10,
            parent: "",
            isFinished: false,
            nodata: true,
            children: []
        }
    },
    mounted() {
        window.ScrollViewTrigger2 = () => {
            this.$refs.listscrollView.triggerRefresh();
        }
    },
    created() {
        this.$store.dispatch('asyncupdateuserinfo');
    },
    methods: {
        $_onRefresh() {
            this.children = [];
            this.page = 1;
            this.isFinished = true;
            this.get_myteam(true);
        },
        $_onEndReached() {
            if (this.isFinished) {
                return
            }
            this.get_myteam(false);
        },
        get_myteam(refresh) {
            let request_data = {
                page: this.page,
                limit: this.limit
            }
            this.$toast.loading("Loading..")
            getmyteam(request_data).then(res=>{
                let that = this;
                setTimeout(() => {
                    that.$toast.hide();
                }, 300);
                if(res.code === 200) {
                    this.teaminfo = res.data;
                    if (res.data.count === 0) {
                        this.nodata = true;
                    } else {
                        this.nodata = false;
                        this.children = this.children.concat(res.data.children);
                    }
                    if (this.children.length < res.data.count) {
                        this.page = this.page + 1;
                        this.isFinished = false;
                    } else {
                        this.isFinished = true;
                    }
                } else {
                    this.$toast.failed(res.errmsg);
                }
                if(refresh) {
                    this.$refs.listscrollView.finishRefresh();
                    this.$refs.listscrollView.finishLoadMore();
                } else {
                    this.$refs.listscrollView.finishLoadMore();
                }
            });
        },
        goto_invitelinkmanage() {
            this.$router.push("/invitelinkmanage");
        }
    }
}
</script>


<style scoped>
.team-list {
    margin-top: 1rem;
    height: 14.3rem;
}
.holder {
  line-height: 0px;
  font-size: 39px;
}

.card {
    margin: 0.9rem 0 0 0 !important;
}
.noassets {
    margin-top: 1.5rem;
}

.noassets>>>.md-result-image {
    width: 1.6rem;
}

.noassets>>>.md-result-text {
    margin: 0;
    color: #01080f;
    font-size: 0.12rem;
}

.noassets>>>.md-result-subtext {
    margin-top: 0.16rem;
    color: red;
    font-size: 0.28rem;
}
</style>


// WEBPACK FOOTER //
// src/views/my/myteam.vue